import store from '@/store'

export const canNavigate = to => to.matched.some(route => route.meta.resource === 'auth' || checkAbility(route) )

export const checkAbility = (route) => {
  const user = store.state.auth.userData
  if (!user) return false
  return [...user.permissions, ... store.state.auth.allUsersPages].includes(route.name) || store.state.auth.userData.roles.includes('Super Admin')
}
